export function copy(value: string) {
  navigator.clipboard.writeText(value)
}
